import React, { useEffect, useState } from "react";
import plusIcon from "../../../../../Assets/Images/Svg/plusIcon.svg";
import AddAllergyDetails from "./AddAllergyDetails";
import { Divider, Modal } from "antd";
import moment from "moment";
import MedicalHistoryService from "../../../../../Services/MedicalHistoryService";
import { useSelector } from "react-redux";
import { FiPlus } from "react-icons/fi";
import dayjs from "dayjs";

function AllergyDetails({ permissionData }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [patientAlleryData, setPatientAlleryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { selectedRpmPatient } = useSelector((state) => state.rpm);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    if (!isLoading) {
      patientAllergies();
    }
  }, [permissionData, isLoading]);

  const patientAllergies = () => {
    const patientRaw = sessionStorage.getItem("patient");
    let patientData = patientRaw ? JSON.parse(patientRaw) : null;

    const userObj = sessionStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;

    const patientCode = patientData?.patientId || selectedRpmPatient?.patientId;

    if (permissionData) {
      let payload = {
        // account_Id: userData?.user?.account_Id,
        // clinic_Id: userData?.user?.clinic_Id,
        userId:
          permissionData === null || permissionData?.medicalHistory === "N"
            ? userData?.user?.userId
            : "",
        patientCode,
        status: 1,
      };
      MedicalHistoryService.PatientAllergiesList(payload)
        .then((result) => {
          setPatientAlleryData(result.data);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  };

  const handleLatestUpdate = (data) => {
    setPatientAlleryData(data);
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes()
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const getAllergiesList = (user) => {
    if (!user) return [];
    const list = [];
    if (user.drugAllergy && user.drugAllergy.trim() !== "") {
      list.push({ label: "Drug Allergies", value: user.drugAllergy });
    }
    if (user.foodAllergy && user.foodAllergy.trim() !== "") {
      list.push({ label: "Food Allergies", value: user.foodAllergy });
    }
    if (user.chemicalAllergy && user.chemicalAllergy.trim() !== "") {
      list.push({ label: "Chemical Allergies", value: user.chemicalAllergy });
    }
    if (user.otherAllergy && user.otherAllergy.trim() !== "") {
      list.push({ label: "Other Allergies", value: user.otherAllergy });
    }
    return list;
  };

  const validAllergyRecords = (patientAlleryData || []).filter((user) => {
    return getAllergiesList(user).length > 0;
  });

  return (
    <div>
      {/* <div className=" h-[300px] m-5 border rounded-lg">
        <div className="h-[20%] bg-brand-primaryColor flex items-center justify-between rounded-lg p-2">
          <h1 className="font-bold text-normal text-white mt-1">
            Allergy Details
          </h1>
          <img
            src={plusIcon}
            onClick={showModal}
            className="h-10 w-10 cursor-pointer"
            alt=""
          />
        </div>
        <div className=" h-[70%] bg-[#DEF3F2] overflow-y-auto items-center custom-scrollbar">
          {patientAlleryData?.map((user, i) => (
            <div key={i} className="mt-3">
              {user?.drugAllergy && (
                <div className="text-sm">
                  <p className="font-semibold mx-3">
                    Drug Allergies:
                    <span className="font-medium text-gray-500">
                      {user.drugAllergy}
                    </span>
                  </p>
                </div>
              )}
              {user?.foodAllergy && (
                <div className="text-sm">
                  <p className="font-semibold mx-3">
                    Food Allergies:
                    <span className="font-medium text-gray-500">
                      {user.foodAllergy}
                    </span>
                  </p>
                </div>
              )}
              {user?.chemicalAllergy && (
                <div className="text-sm">
                  <p className="font-semibold mx-3">
                    Chemical Allergies:
                    <span className="font-medium text-gray-500">
                      {user.chemicalAllergy}
                    </span>
                  </p>
                </div>
              )}
              {user?.otherAllergy && (
                <div className="text-sm">
                  <p className="font-semibold mx-3">
                    Other Allergies:
                    <span className="font-medium text-gray-500">
                      {user.otherAllergy}
                    </span>
                  </p>
                </div>
              )}
              <div className="flex justify-end">
                <div className="font-medium text-sm mt-2">
                  Check up date : {user.givenDate?.slice(0, 11)}
                </div>
              </div>
              {i !== patientAlleryData.length - 1 && (
                <hr className="my-4 border-gray-300" />
              )}
            </div>
          ))}
        </div>
        <div className="footer h-[10%]  bg-brand-primaryColor rounded-md"></div>
      </div> */}

      <div
        className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
        id="unquie-scroll"
      >
        <div className="flex justify-between items-center p-3">
          <h3 className="text-sm font-bold text-gray-700">Allergy Details</h3>
          <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
            <div
              onClick={showModal}
              className="w-6 h-6 rounded-full flex items-center justify-center bg-brand-primaryColor"
            >
              <FiPlus className="text-white w-4 h-4" />
            </div>
            {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
          </div>
        </div>
        <hr />
        <div className="h-52 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
          {validAllergyRecords && validAllergyRecords.length > 0 ? (
            validAllergyRecords.map((user, i) => {
              const allergies = getAllergiesList(user);
              const firstAllergy = allergies[0];
              return (
                <div
                  key={i}
                  className="relative"
                  onMouseEnter={() => setHoveredIndex(i)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                    <div className="bg-[#F7FFFE] border border-[#95F0DF] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                      <p>
                        <strong>{firstAllergy.label}:</strong>{" "}
                        {firstAllergy.value}
                      </p>
                      {user.givenDate && (
                        <p>
                          Onset Date :{" "}
                          {dayjs(user.givenDate).format("YYYY-MM-DD")}
                        </p>
                      )}
                    </div>
                  </div>
                  {hoveredIndex === i && (
                    <div className="absolute top-0 left-0 w-full bg-[#585858] text-white text-xs rounded-lg shadow-lg p-3 z-50 flex flex-col gap-1">
                      {allergies.map((item, idx) => (
                        <p key={idx}>
                          <strong>{item.label}:</strong> {item.value}
                        </p>
                      ))}
                      {user.givenDate && (
                        <p>
                          <strong>Onset date:</strong>{" "}
                          {dayjs(user.givenDate).format("YYYY-MM-DD")}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <div></div>
          )}
        </div>
      </div>

      <Modal
        title={<span className="font-bold text-base">Add Allergy Details</span>}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <AddAllergyDetails
          handleOk={handleOk}
          handleCancel={handleCancel}
          patientAllergies={patientAllergies}
          onClose={handleCancel}
          handleLatestUpdate={handleLatestUpdate}
          permissionData={permissionData}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </Modal>
    </div>
  );
}

export default AllergyDetails;
